import Api from '../../api'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import { addSettings } from 'portal-modules/common/redux/modules/settings'
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { addCustomContent } from 'portal-modules/common/redux/modules/customContent'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import createFormAction from 'portal-modules/common/redux/create-form-action'

// action types
const ADD_VEHICLE = 'rp/vehicles/ADD_VEHICLE'
const DELETE_VEHICLE = 'rp/vehicles/DELETE_VEHICLE'
const VEHICLE_ADDED = 'rp/vehicles/VEHICLE_ADDED'
const VEHICLE_DELETED = 'rp/vehicles/VEHICLE_DELETED'
const RECEIVE_VEHICLES = 'rp/vehicles/RECEIVE_VEHICLES'
const REQUEST_VEHICLES = 'rp/vehicles/REQUEST_VEHICLES'
const UPDATE_VEHICLE = 'rp/vehicles/UPDATE_VEHICLE'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_VEHICLES:
      return { ...state, ...payload }
    case VEHICLE_ADDED:
      return {
        ...state,
        [payload.id]: payload,
      }
    case VEHICLE_DELETED:
      return Object.values(state).reduce((obj, vehicle) => {
        if (vehicle.id === payload) return obj
        return { ...obj, [vehicle.id]: vehicle }
      }, {})
    case UPDATE_VEHICLE:
      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          ...payload,
        },
      }
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const requestVehicles = () => ({ type: REQUEST_VEHICLES })

export const receiveVehicles = payload => ({
  type: RECEIVE_VEHICLES,
  payload,
})

export const addVehicle = createFormAction(ADD_VEHICLE)

export const deleteVehicle = (payload, callback) => ({
  type: DELETE_VEHICLE,
  callback,
  payload,
})

export const updateVehicle = createFormAction(UPDATE_VEHICLE)

// sagas
function* fetchVehicles() {
  const { list, settings } = yield call(Api.getListWithSettings)

  let actions = []

  if (Array.isArray(list) && list.length) {
    const vehiclesObject = list.reduce((obj, v) => ({ ...obj, [v.id]: v }), {})
    actions.push(receiveVehicles(vehiclesObject))
  }

  if (settings) {
    actions.push(addSettings({ vehicles: settings }))
    actions.push(addCustomContent({ vehicles: settings.custom_text }))
  }

  yield all(actions.map(a => put(a)))
}

function* postDeleteVehicle({ payload }) {
  yield call(Api.deleteVehicle, { id: payload })
  yield put({ type: VEHICLE_DELETED, payload })
}

function* addOrEditVehicle({ payload, type }) {
  const { vehicle } = yield call(Api.saveVehicle, payload)
  if (vehicle && (type === ADD_VEHICLE || type === UPDATE_VEHICLE)) {
    yield put({ type: VEHICLE_ADDED, payload: vehicle })
  }
}

function* watchGetVehicles() {
  yield takeLatest(
    REQUEST_VEHICLES,
    createRequestSaga(fetchVehicles, {
      key: 'vehicles',
      message: __('Checking for vehicles'),
    }),
  )
}

function* watchDeleteVehicle() {
  yield takeEvery(
    DELETE_VEHICLE,
    createRequestSaga(postDeleteVehicle, {
      key: 'vehicles',
      message: __('Deleting vehicle'),
      successMessage: __('Vehicle deleted'),
      write: true,
    }),
  )
}

function* watchAddOrUpdateVehicle() {
  yield takeEvery(
    [ADD_VEHICLE, UPDATE_VEHICLE],
    createRequestSaga(addOrEditVehicle, {
      key: 'vehicles',
      message: __('Syncing updates'),
      successMessage: __('Vehicle saved'),
      write: true,
    }),
  )
}

export const sagas = [
  watchGetVehicles,
  watchDeleteVehicle,
  watchAddOrUpdateVehicle,
]
